export default __webpack_public_path__ + "static/media/Set-Up-Agenda-Graphic.3b2fc214.jpg";